import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition } from "vue"
import _imports_0 from '../assets/workforce-kit-app-logo.svg'


const _hoisted_1 = {
  key: 0,
  class: "container-fluid px-0 d-flex"
}
const _hoisted_2 = { class: "d-flex mb-2 pt-1 ml-lg-n3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: _imports_0
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("svg", {
  fill: "#000000",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  width: "24px",
  height: "24px"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M 2 5 L 2 7 L 22 7 L 22 5 L 2 5 z M 2 11 L 2 13 L 22 13 L 22 11 L 2 11 z M 2 17 L 2 19 L 22 19 L 22 17 L 2 17 z" })
], -1)
const _hoisted_5 = [
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Sidebar = _resolveComponent("Sidebar")!
  const _component_Header = _resolveComponent("Header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_toast = _resolveComponent("toast")!

  return (_ctx.organisation && _ctx.employee)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_Transition, { name: "slide-fade" }, {
          default: _withCtx(() => [
            (_ctx.show || _ctx.toggleButton)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(`text-left shadow-sm scroll bg-primary ${
          _ctx.toggleButton ? 'sidebar' : 'sidebar-full'
        }`)
                }, [
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_router_link, {
                      class: "mx-auto",
                      to: "/"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_3
                      ]),
                      _: 1
                    })
                  ]),
                  _withDirectives(_createElementVNode("span", {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleButton = !_ctx.toggleButton)),
                    "aria-hidden": "true",
                    class: "size-mod"
                  }, "×", 512), [
                    [_vShow, !_ctx.show]
                  ]),
                  _createVNode(_component_Sidebar)
                ], 2))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createElementVNode("div", {
          class: _normalizeClass(`${!_ctx.show ? 'main-content-full' : 'main-content'}`)
        }, [
          _createElementVNode("div", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleButton = false)),
            class: _normalizeClass(`${_ctx.toggleButton ? 'sidebar-overlay on' : 'sidebar-overlay'}`)
          }, null, 2),
          _createVNode(_component_Header, null, {
            toggleBtn: _withCtx(() => [
              _withDirectives(_createElementVNode("button", {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleButton = !_ctx.toggleButton)),
                class: "btn btn-light mr-3 px-1 py-0"
              }, _hoisted_5, 512), [
                [_vShow, !_ctx.show]
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_router_view),
          _createVNode(_component_toast)
        ], 2)
      ]))
    : _createCommentVNode("", true)
}